export const FETCH_GAS_STATIONS = 'FETCH_GAS_STATIONS';
export const FETCH_GAS_STATION_COUNT = 'FETCH_GAS_STATION_COUNT';
export const ADD_GAS_STATION_SUCCESS = 'ADD_GAS_STATION_SUCCESS';
export const EDIT_GAS_STATION_SUCCESS = 'EDIT_GAS_STATION_SUCCESS';
